import React, { Component } from 'react'
import { Box, Card, Checkbox, Grid, LinearProgress, ListItemText, Typography, IconButton, Tooltip } from '@mui/material';
import { ListItem } from 'react-bootstrap/lib/Media';
import SFBarChart from './SFBarChart';
import SFTable from './SFTable';
import { PiCaretCircleUp, PiCaretCircleDown } from "react-icons/pi";

import { IoTimerSharp } from "react-icons/io5";
import { TbTargetArrow } from "react-icons/tb";
import moment from 'moment';
import Toggle from 'react-toggle';
import "react-toggle/style.css";
import { IoInformationCircle } from "react-icons/io5";
import LoadingSpinner from '../LoadingSpinner';
import ApiRequestService from '../ApiRequestService';

const defaultColumns = [
    {
        id: 'expand',
        name: 'Expand',
        width: "20px",
        visible: false,
    },
    {
        id: 'name',
        name: 'Category Name',
        width: "300px",
    },
    {
        id: 'accuracy_percent',
        name: 'Accuracy %',
        width: "200px",
    },
    {
        id: 'time',
        name: 'Total Time',
        width: "200px",
    },
    {
        id: 'actions',
        name: 'Add to Practice set',
        width: "100px",
        center: true
    },
]

export default class SFAssignmentDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            assignments: [],
            categories: [],
            selectedAssignment: null,
            selectedCatIndex: 0,
            loading: false,
            columns: [...defaultColumns],
        }

    }

    componentDidMount() {
        // this.fetchStudentAssignments()
        if (this.props.selectedCourse) {
            this.setState({
                loading: true
            })
            this.props.handleUpdateCount(0);
            this.getByAssignments();
            this.updateColumns();
        }
    }

    updateColumns = () => {
        let updatedColumns = defaultColumns.map(col => ({ ...col }));
        if (this.props.selectedStudentUserName) {
            updatedColumns.pop();
        }
        if (this.props.selectedStudentUserName === "all") {
            updatedColumns[2].name = "Mean Accuracy %";
            let colThree = updatedColumns[3];
            updatedColumns[3] = {
                id: 'accuracy_index',
                name: 'Mean Accuracy Index',
                width: "200px",
            };
            colThree.name = "Median Time";
            updatedColumns[4] = colThree;
            console.debug("updatedColumns", updatedColumns)
        }
        this.setState({
            columns: updatedColumns
        })
    }

    componentDidUpdate(prevProps) {
        console.debug("prevProps.selectedCourse>>??", prevProps.selectedStudentUserName)
        if (prevProps.selectedCourse?.course_id !== this.props.selectedCourse?.course_id
            || prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.setState({
                loading: true
            })
            this.getByAssignments()
            this.updateColumns()
        }
    }

    getByAssignments = () => {
        if (this.props.selectedStudentUserName === "all" &&
            this.props.savedAssignmentsForAllStudents && this.props.savedAssignmentsForAllStudents.length) {
            this.setState({
                assignments: this.props.savedAssignmentsForAllStudents,
                selectedAssignment: this.props.savedAssignmentsForAllStudents[0],
                categories: this.props.savedAssignmentsForAllStudents[0].categoryDataArr,
                loading: false,
            })
            this.props.handleUpdateCount(this.props.savedAssignmentsForAllStudents.length);
            return;
        }
        let payload = {
            tabIndex: 0,
            courseID: this.props.selectedCourse.course_id,
            sectionID: this.props.selectedCourse.section_id,
            userName: this.props.selectedStudentUserName,
            sectionID: this.props.selectedInstructorSectionID
        }
        console.debug("payload>>", payload)
        if (this.props.selectedStudentUserName === "all") {
            payload.allStudents = true
        }

        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getByAssignments",
            data: payload
        });

        responsePromise
            .then((res) => {
                let count = 0;
                if (res && res.data && res.data.data) {
                    this.setState({
                        assignments: res.data.data,
                    })
                    if (payload.userName === "all") {
                        let key = `${this.props.selectedCourse.course_id}_${this.props.selectedCourse.section_id}`;
                        this.props.updateSavedAssignmentsForAllStudents(key, res.data.data);
                    }

                    count = res.data.data.length;
                    if (res.data.data && res.data.data.length) {
                        let categories = res.data.data[0].categoryDataArr;
                        if (categories && categories.length) {
                            categories[0].expand = true;
                        }
                        this.setState({
                            selectedAssignment: res.data.data[0],
                            categories: categories
                        })
                    }
                } else {
                    this.setState({
                        assignments: [],
                        selectedAssignment: null,
                        categories: null
                    })
                    count = 0;
                }
                this.props.handleUpdateCount(count);
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {
                this.setState({
                    loading: false
                })
            });
    }

    fetchStudentAssignments = () => {
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getStudentDashboardAssignments",
            data: {
                course_id: -1,
                tabName: "byassignments"
            }
        });
        responsePromise
            .then((res) => {
                if (res && res.data && res.data.data) {
                    console.debug("res.data.data", res.data.data)
                    this.setState({
                        assignments: res.data.data,
                        selectedAssignment: res.data.data[0]
                    })
                }
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {

            });
    };

    // Get all completed assignments by student and enrolled courses

    handleExpand = (index) => {
        let value = this.state.categories[index].expand !== undefined ? !this.state.categories[index].expand : true
        let updatedData = {
            ...this.state.categories[index],
            expand: value,
        }
        let updatedCategories = [...this.state.categories];
        updatedCategories[index] = updatedData;

        console.debug("updatedCategories", updatedCategories, updatedData)

        this.setState({
            categories: updatedCategories
        })

        const activityPayload = {
            toNomenclatureID: value ? 1 : 2,
            quizID: this.state.selectedAssignment.quizID,
            subjectID: updatedData.subjectID,
            topicID: updatedData.topicID,
            categoryID: updatedData.categoryID,
            activityTypeID: 14, // Time Clicked on "Category"
        }
        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(activityPayload);
        }
    }

    handleToggle = (index, value) => {
        let updatedData = {
            ...this.state.categories[index],
            current: value,
        }
        let updatedCategories = [...this.state.categories];
        updatedCategories[index] = updatedData;

        this.setState({
            categories: updatedCategories
        })

        const activityPayload = {
            toNomenclatureID: value ? 4 : 3, // 4 - History, 3 - Current
            quizID: this.state.selectedAssignment.quizID,
            subjectID: updatedData.subjectID,
            topicID: updatedData.topicID,
            categoryID: updatedData.categoryID,
            activityTypeID: 26, // Toggle
        }
        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(activityPayload);
        }
    }

    handleAddToPractice = (catData, index) => {
        this.props.handleAddCategory(catData);

        let logPayload = {
            toNomenclatureID: 5, // 6-checked
            quizID: this.state.selectedAssignment ? this.state.selectedAssignment.quizID : 0,
            subjectID: catData.subjectID,
            topicID: catData.topicID,
            categoryID: catData.categoryID,
            activityTypeID: 14, // "Category" activity in p&p page
        };

        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(logPayload)
        }

    }

    handleRemovFromPractice = (catData, index) => {
        this.props.handleRemoveCategory(catData);

        let logPayload = {
            toNomenclatureID: 6, // 6-unchecked
            quizID: this.state.selectedAssignment ? this.state.selectedAssignment.quizID : 0,
            subjectID: catData.subjectID,
            topicID: catData.topicID,
            categoryID: catData.categoryID,
            activityTypeID: 14, // "Category" activity in p&p page
        };

        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(logPayload)
        }

    }

    getReadableTime = (timeInSec) => {
        if (timeInSec <= 60) {
            return `${timeInSec} sec`
        }
        let min = moment.duration(timeInSec, 'seconds').minutes()
        let sec = moment.duration(timeInSec, 'seconds').seconds()

        return `${min}m ${sec}s`
    }

    renderRow(data, index, isInstructor, renderRowProps) {
        console.debug("data.categoryPracticeDataArr", data)

        function getReadableTime(timeInSec) {
            if (timeInSec <= 60) {
                return `${timeInSec} sec`
            }
            let min = moment.duration(timeInSec, 'seconds').minutes()
            let sec = moment.duration(timeInSec, 'seconds').seconds()

            return `${min}m ${sec}s`
        }

        let catKey = `${data.subjectID}_${data.topicID}_${data.categoryID}`
        let catIsAlreadyAdded = false;
        if (this.selectedCategories && this.selectedCategories.length) {
            this.selectedCategories.forEach(selectedCat => {
                if (`${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.categoryID}` === catKey) {
                    catIsAlreadyAdded = true;
                }
            });
        }

        let isCurrent = false;
        if (data.current === undefined || data.current) {
            isCurrent = true;
        }

        console.debug("isCurrent>>>>", isCurrent, data.current)

        let categoryDataArr = data.categoryPracticeDataArr;
        if (!isCurrent) {
            categoryDataArr = data.categoryPracticeDataAcrossArr;
        }

        console.debug("categoryDataArr>>??", categoryDataArr, isCurrent)

        return (
            <div>
                <div className='sf-table-row cursor-pointer'
                    onClick={(event) => {

                        console.debug("event", event.target.type)
                        if (event.target && event.target.type === "checkbox") return;
                        this.handleExpand(index)
                    }}>

                    <div className='sf-table-row-div' style={{ width: '20px' }}>
                        <IconButton>
                            {data.expand ?
                                <PiCaretCircleDown fontSize={24} color='#333' />
                                : <PiCaretCircleUp fontSize={24} color='#333' />}

                        </IconButton>
                    </div>
                    <div className='sf-table-row-div' style={{ width: '300px', justifyContent: "start" }}>
                        {data.name}
                    </div>
                    <div className='sf-table-row-div' style={{ width: '200px' }}>
                        <div className='w-100 h-100 text-align-center'>
                            <div>{data.masteryAccuracyPercent}%</div>
                            <div>
                                <LinearProgress
                                    style={{ height: '8px', borderRadius: '75px' }}
                                    variant="determinate" value={data.masteryAccuracyPercent} />
                            </div>
                        </div>
                    </div>
                    {renderRowProps.selectedStudentUserName === "all" ?
                        <div className='sf-table-row-div' style={{ width: '200px' }}>
                            <div className='w-100 h-100 text-align-center'>
                                <div>{data.masteryAccuracy}%</div>
                                <div>
                                    <LinearProgress
                                        style={{ height: '8px', borderRadius: '75px' }}
                                        variant="determinate" value={data.masteryAccuracy} />
                                </div>
                            </div>
                        </div>
                        : null}
                    <div className='sf-table-row-div' style={{ width: '200px' }}>
                        <div className='text-center' style={{ color: '#0F7C27' }}>
                            <div className='fontClass-22'>
                                {getReadableTime(data.masteryTime)}
                            </div>
                            <div>{data.speed_message}</div>
                        </div>
                    </div>
                    {renderRowProps.selectedStudentUserName ? null :
                        <div className='sf-table-row-div' style={{ width: '100px' }}>
                            <Checkbox
                                style={{
                                    zIndex: '99 !important'
                                }}
                                disabled={isInstructor}
                                id={catKey}
                                checked={catIsAlreadyAdded}
                                onChange={(event) => {

                                    let value = event.target.checked;
                                    if (value) {
                                        this.handleAddToPractice(data, index)
                                    } else {
                                        this.handleRemovFromPractice(data, index)
                                    }
                                }}
                            />
                        </div>
                    }
                </div>

                <div style={{
                    display: data.expand ? "block" : 'none'
                }}>
                    <Box style={{
                        height: '400px',
                        width: '100%',
                        background: 'white',
                    }} className="d-flex flex-column justify-content-center align-items-center">
                        {renderRowProps.selectedStudentUserName === "all" ? null :
                            (
                                <div className='d-flex justify-content-center align-items-center mt-3'>
                                    <Tooltip title={
                                        <Typography fontSize={12} color='#fff'>
                                            Current assignment/set data
                                        </Typography>
                                    } placement="top" arrow>

                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <IoInformationCircle fontSize={16} color='#646a6e' />
                                            <Typography fontSize={14}
                                                fontWeight={isCurrent ? 800 : 500}
                                            >
                                                {renderRowProps.selectedStudentUserName === "all" ? "Mean/Median" : "Current"}
                                            </Typography>
                                        </div>
                                    </Tooltip>
                                    <Toggle
                                        id="accuracy_or_time"
                                        icons={false}
                                        className="mx-3 perf-toggle"
                                        checked={!isCurrent}
                                        onChange={() => {
                                            this.handleToggle(index, !isCurrent)
                                        }}
                                    />
                                    <Tooltip title={
                                        <Typography fontSize={12} color='#fff'>
                                            Data across all assignments/sets
                                        </Typography>
                                    } placement="top" arrow>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Typography fontSize={14}
                                                fontWeight={!isCurrent ? 800 : 500}
                                            >
                                                {renderRowProps.selectedStudentUserName === "all" ? "All Students" : "History"}
                                            </Typography>
                                            <IoInformationCircle fontSize={16} color='#646a6e' />
                                        </div>
                                    </Tooltip>
                                </div>
                            )}
                        <div className="d-flex justify-content-center align-items-center h-100 w-100" style={{
                            marginTop: "-8px",
                            gap: "2rem",
                        }}>
                            {/* {renderRowProps.selectedStudentUserName === "all" ?
                                <SFScatterChart
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <TbTargetArrow fontSize={22} /> Accuracy
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"# Students"}
                                    yAxisLabel={"Accuracy %"}
                                    dataArr={data?.studentCategoryDataArr?.map((cp, index) => {
                                        return {
                                            x: index + 1,
                                            y: cp.accuracyIndex,
                                            label: cp.userName,
                                        }
                                    })}
                                    min={0}
                                    max={100}
                                    stepSize={20}
                                />
                                : */}
                            <SFBarChart
                                title={
                                    <div className='pl-5'>
                                        <center>
                                            <Typography fontSize={14} fontWeight={600} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <TbTargetArrow fontSize={22} />
                                                {renderRowProps.selectedStudentUserName === "all" ? "Mean Accuracy %" : "Accuracy %"}
                                            </Typography>
                                        </center>
                                    </div>
                                }
                                format="%"
                                type={"linear"}
                                xAxisLabel={"Attempts #"}
                                yAxisLabel={renderRowProps.selectedStudentUserName === "all" ? "Mean Accuracy %" : "Accuracy %"}
                                isPractice={false}
                                labels={categoryDataArr ? categoryDataArr.map((_, index) => index + 1) : []}
                                dataArr={categoryDataArr ? categoryDataArr.map(cat => cat.accuracyPercent) : []}
                                practiceDataArr={categoryDataArr ? categoryDataArr.map(cat => cat.accuracyGoal) : []}
                                min={0}
                                max={100}
                                stepSize={20}
                            />
                            {renderRowProps.selectedStudentUserName === "all" ?
                                <SFBarChart
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <TbTargetArrow fontSize={22} />
                                                    Mean Accuracy Index
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"Attempts #"}
                                    yAxisLabel={"Mean Accuracy Index"}
                                    isPractice={false}
                                    labels={categoryDataArr ? categoryDataArr.map((_, index) => index + 1) : []}
                                    dataArr={categoryDataArr ? categoryDataArr.map(cat => cat.accuracy) : []}
                                    practiceDataArr={categoryDataArr ? categoryDataArr.map(cat => cat.accuracyGoal) : []}
                                    min={0}
                                    max={100}
                                    stepSize={20}
                                />
                                : null}
                            {/* } */}

                            {/* {renderRowProps.selectedStudentUserName === "all"  ?
                                <SFScatterChart
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <TbTargetArrow fontSize={22} /> Time Take (min)
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"# Students"}
                                    yAxisLabel={"Time Take (min)"}
                                    dataArr={data?.studentCategoryDataArr?.map((cp, index) => {
                                        return {
                                            x: index + 1,
                                            y: parseFloat((cp.time / 60).toFixed(1)),
                                            label: cp.userName,
                                        }
                                    })}
                                    min={0}
                                    max={100}
                                    stepSize={20}
                                />
                                :  */}
                            <SFBarChart
                                title={
                                    <div className='pl-5'>
                                        <center>
                                            <Typography fontSize={14} fontWeight={600} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <IoTimerSharp fontSize={22} />

                                                {renderRowProps.selectedStudentUserName === "all" ? "Median Time Taken (min)" : "Time Taken (min)"}
                                            </Typography>
                                        </center>
                                    </div>
                                }
                                format="m"
                                type={"logarithmic"}
                                xAxisLabel={"Attempts #"}
                                yAxisLabel={renderRowProps.selectedStudentUserName === "all" ? "Median Time Take (min)" : "Time Take (min)"}
                                isPractice={false}
                                labels={categoryDataArr ? categoryDataArr?.map((_, index) => index + 1) : []}
                                dataArr={categoryDataArr ? categoryDataArr?.map(cat => {
                                    return parseFloat((cat.time / 60).toFixed(1))
                                }) : []}
                                practiceDataArr={categoryDataArr ? categoryDataArr?.map(cat => {
                                    return cat.timeGoal
                                }) : []}
                                min={0}
                                max={0}
                                stepSize={1}
                            />
                            {/* } */}
                        </div>

                    </Box>
                </div>

                <div className='justify-content-center align-items-center pb-4 pt-3' style={{
                    gap: "2rem",
                    display: data.expand ? "flex" : 'none',
                    background: "#fff",
                }}>
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#0077B9", width: "30px", height: "7px" }}></div>
                        Graded
                    </div>
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#FF5287", width: "30px", height: "7px" }}></div>
                        Practice
                    </div>
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#D6AAAC", width: "30px", height: "7px", borderRadius: "15px" }}></div>
                        Goal
                    </div>
                </div>

            </div>
        )
    }


    render() {

        const { assignments, selectedAssignment, loading } = this.state;

        if (loading) {
            return (
                <div className='sf-fixed-center'>
                    <LoadingSpinner />
                </div>
            )
        }

        if (assignments && assignments.length === 0) {
            return (
                <div className='sf-fixed-center'>
                    <Typography fontSize={24} fontWeight={500}>
                        No Data Found.
                    </Typography>
                </div>
            )
        }

        return (
            <Grid container spacing={2} className='sf-pa-gird'>
                <Grid item
                    md={2}
                    sm={2}
                    xs={2}
                    className='sf-assig-list p-0 mt-3 pl-4'
                    style={{
                        // height: this.props.selectedStudentUserName === "all" ? "calc(100% - 65px)" : "100vh",
                        height: "100vh",
                    }}
                >
                    <Card className='pr-3 pr-2 overflow-auto' style={{
                        // height: this.props.selectedStudentUserName === "all" ? "calc(100% - 65px)" : "100vh",
                        height: "100vh",
                    }}>
                        <Typography className='py-2' textAlign={'center'} fontSize={16} fontWeight={700}>
                            Assignment Name
                        </Typography>
                        {assignments.map((assign, index) => {
                            return (
                                <ListItem key={index}
                                    style={{
                                        listStyle: 'none'
                                    }}
                                    className={`
                                    ${selectedAssignment?.quizID === assign.quizID ? "pa-assignment-selected " : " "}

                                    pa-assignment mb-1 pl-3
                                `}
                                    onClick={() => {

                                        let categories = assign.categoryDataArr;
                                        if (categories && categories.length) {
                                            categories[0].expand = true;
                                        }

                                        this.setState({
                                            selectedAssignment: assign,
                                            categories: categories
                                        })

                                        let logPayload = {
                                            toNomenclatureID: 0, // clicked
                                            quizID: assign.quizID,
                                            subjectID: assign.subjectID,
                                            topicID: assign.topicID,
                                            categoryID: 0,
                                            activityTypeID: 19, // "Assignment" activity in p&p page
                                        };

                                        if (this.props.onAddActivityLog) {
                                            this.props.onAddActivityLog(logPayload);
                                        }
                                    }}
                                >
                                    <ListItemText>{assign.quizName}</ListItemText>
                                </ListItem>
                            )
                        })}
                    </Card>
                </Grid>
                <Grid item
                    md={10}
                    xs={10}
                    sm={10}
                    className='sf-pa-list'
                    style={{
                        height: this.props.selectedStudentUserName === "all" ? "calc(100% - 65px)" : "100%",
                    }}
                >
                    <div style={{ width: "100%", height: '100%' }}>

                        <div className='d-flex justify-content-between align-items-start'>
                            <div>
                                <Typography fontSize={30} fontWeight='bold'>
                                    {selectedAssignment?.quizName}
                                </Typography>
                            </div>
                            {/* Mini details */}
                            <div className='sf-pa-boxes-container mt-1' style={{
                                display: this.props.selectedStudentUserName === "all" ? 'none' : 'flex'
                            }}>
                                <Box sx={{ boxShadow: 1 }} className='sf-pa-box sf-pa-box-red'>
                                    <Typography fontSize={24} color='primary'>
                                        {/* {selectedAssignment?.score} */}
                                        100%
                                    </Typography>
                                    <small>
                                        <Typography color='primary'>Score</Typography>
                                    </small>
                                </Box>
                                <Box sx={{ boxShadow: 1 }} className='sf-pa-box'>
                                    <Typography fontSize={24}>
                                        {selectedAssignment ?
                                            `${selectedAssignment?.completedCategories}/${selectedAssignment?.totalCategories}`
                                            : ""}
                                    </Typography>
                                    <small>
                                        <Typography>Mastered</Typography>
                                    </small>
                                </Box>
                                <Box sx={{ boxShadow: 1 }} className='sf-pa-box'>
                                    <Typography fontSize={24}>
                                        {selectedAssignment?.questionsCompleted}
                                    </Typography>
                                    <small>
                                        <Typography>Questions Completed</Typography>
                                    </small>
                                </Box>
                                <Box sx={{ boxShadow: 1 }} className='sf-pa-box'>
                                    <Typography fontSize={24}>
                                        {selectedAssignment?.questionsCorrect}
                                    </Typography>
                                    <small>
                                        <Typography>Questions Correct</Typography>
                                    </small>
                                </Box>
                                <Box sx={{ boxShadow: 1 }} className='sf-pa-box'>
                                    <Typography fontSize={24}>
                                        {this.getReadableTime(selectedAssignment?.timeTaken)}
                                        {/* {selectedAssignment?.timeTaken.toFixed(1)} */}
                                    </Typography>
                                    <small>
                                        <Typography>Time Taken</Typography>
                                    </small>
                                </Box>
                            </div>
                        </div>

                        {/* Category Table */}
                        <div className='mt-3 w-100 position-relative d-flex justify-content-start align-items-start'
                            style={{
                                height: this.props.selectedStudentUserName === "all" ? "calc(100% - 65px)" : "calc(100% - 65px)",
                                gap: "1rem"
                            }}
                        >
                            <SFTable
                                columns={this.state.columns}
                                dataArr={this.state.categories || null}
                                renderRow={this.renderRow}
                                isInstructor={this.props.isInstructor}
                                handleExpand={this.handleExpand}
                                handleToggle={this.handleToggle}
                                handleAddToPractice={this.handleAddToPractice}
                                handleRemovFromPractice={this.handleRemovFromPractice}
                                selectedCategories={this.props.selectedCategories}
                                selectedAssignment={selectedAssignment}
                                onAddActivityLog={this.props.onAddActivityLog}
                                selectedStudentUserName={this.props.selectedStudentUserName}
                            />
                            {/* {this.props.selectedCategories && this.props.selectedCategories.length ?
                                <div style={{
                                    height: 'calc(100% - 0px)',
                                }}> */}
                            {/* <SFPracticeSetCart
                                        handleRemovFromPractice={this.handleRemovFromPractice}
                                        handleClearCart={this.props.handleClearCart}
                                        selectedCategories={this.props.selectedCategories}
                                        handleRoute={this.props.handleRoute}
                                        onAddActivityLog={this.props.onAddActivityLog}
                                    /> */}
                            {/* </div>
                                : null} */}
                        </div>

                    </div>

                </Grid>
            </Grid>
        )
    }
}

